exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable > thead > tr > th[data-v-464c424c] {\n    vertical-align: middle;\n}\n.table > tbody + tbody[data-v-464c424c] {\n    border-top: none;\n}\n", ""]);

// exports
